import { render, staticRenderFns } from "./ProductMatrix.vue?vue&type=template&id=13ea6770&scoped=true&"
import script from "./ProductMatrix.vue?vue&type=script&lang=ts&"
export * from "./ProductMatrix.vue?vue&type=script&lang=ts&"
import style0 from "./ProductMatrix.vue?vue&type=style&index=0&id=13ea6770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ea6770",
  null
  
)

export default component.exports